/**
 * ESCAPE HTML — SSOT del proyecto.
 *
 * Convierte texto crudo (de un usuario, de la DB, de un QR impreso por un
 * tercero) en algo que un navegador muestra como TEXTO y nunca ejecuta como
 * marcado. Vive en `shared/utils/` porque el problema es de todos los fronts:
 * había copias sueltas en `front-admin/js/utils/` y en `shared/services/
 * fuzzy-search.js`, y una copia que se queda vieja es una vulnerabilidad
 * esperando su turno.
 *
 * CUÁNDO: siempre que un dato ajeno se concatene dentro de un string que
 * termina en `innerHTML`. Si el destino es `textContent`, no hace falta — el
 * navegador ya lo trata como texto.
 *
 * CUÁNDO NO: para URLs (`encodeURI`/`encodeURIComponent`) ni para JSON dentro
 * de `<script>` (`JSON.stringify` + escapar `</script>`). Escapar entidades
 * HTML no protege en esos contextos.
 *
 * OJO con el viaje de vuelta: `.textContent` devuelve el texto YA
 * DESESCAPADO. Releer del DOM lo escapado y volver a interpolarlo deshace
 * este trabajo — hay que escapar en el punto de interpolación, con el dato
 * original en la mano.
 */

const MAPA_CARACTER_A_ENTIDAD_HTML = Object.freeze({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
});

const PATRON_CARACTERES_PELIGROSOS_EN_HTML = /[&<>"']/g;

/**
 * @param {*} textoCrudoDeUsuarioODb - cualquier valor; null/undefined → ''.
 * @returns {string} seguro para concatenar dentro de `innerHTML`.
 */
export function escapeHtml(textoCrudoDeUsuarioODb) {
    if (textoCrudoDeUsuarioODb === null || textoCrudoDeUsuarioODb === undefined) {
        return '';
    }
    return String(textoCrudoDeUsuarioODb).replace(
        PATRON_CARACTERES_PELIGROSOS_EN_HTML,
        caracter => MAPA_CARACTER_A_ENTIDAD_HTML[caracter]
    );
}

export default escapeHtml;

// Consumible también desde CommonJS (backend, scripts, tests con require).
if (typeof module !== 'undefined' && module.exports) {
    module.exports = { escapeHtml, default: escapeHtml };
}
